import SentryHelper from "./_sentry-helper";
import {SeverityLevel} from "@sentry/browser";

export default function(){
    SentryHelper.log(
        'Sentry JS logging test via admin control panel.',
        <SeverityLevel>'info',
        'This is some context'
    );

    throw 'Sentry JS exception test via admin control panel.';
}